"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _AiStarsV = _interopRequireDefault(require("@insided/destination/icons/AiStarsV3"));

/**
 * AIAnswersHeader Component
 *
 * A reusable header component that displays the AI Answers branding
 * with the AI icon and title text.
 *
 * @example
 * ```tsx
 * <AIAnswersHeader />
 * <AIAnswersHeader className="custom-class" iconWidth={24} />
 * <AIAnswersHeader title="Custom AI Title" />
 * ```
 */
var AIAnswersHeader = function AIAnswersHeader(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? 24 : _ref$iconWidth,
      _ref$iconHeight = _ref.iconHeight,
      iconHeight = _ref$iconHeight === void 0 ? 24 : _ref$iconHeight,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'var(--config--main-color-brand)' : _ref$iconColor,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'AI Answers' : _ref$title,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading;
  var classNames = className ? "ai-answers-header ".concat(className) : 'ai-answers-header';
  var headerClassNames = loading ? "".concat(classNames, " ai-answers-header--loading") : classNames;
  return (0, _preact.h)("div", {
    className: headerClassNames,
    style: {
      color: iconColor
    }
  }, (0, _preact.h)(_AiStarsV.default, {
    width: iconWidth,
    height: iconHeight
  }), (0, _preact.h)("span", {
    className: "ai-answers-title"
  }, title));
};

var _default = AIAnswersHeader;
exports.default = _default;